export const hostnamesData: HostDomainsInterface[] = [
    {
        domain: 'checkout.proticket.store',
        mainLogo: 'assets/images/logo/pro-ticket-logo.png',
        shopRedirectUrl: 'proticket.store',
        iconLogo:  'assets/images/logo/logo-simbolo.png',
        tittle: 'Proticket | All in one ticketing platform for real events',
        organization: 'Proticket'
    },

    {
        domain: 'checkout.ticketpro.store',
        mainLogo: 'assets/images/logo/ticketpro/ticketpro-logo-purple.svg',
        shopRedirectUrl: 'ticketpro.store',
        iconLogo:  'assets/images/logo/ticketpro/ticketpro-icon-purple.png',
        tittle: 'TicketPro | All in one ticketing platform for real events',
        organization: 'TicketPro'

    },
    {
        domain: 'dev.ticketpro.store',
        mainLogo: 'assets/images/logo/ticketpro/ticketpro-logo-purple.svg',
        shopRedirectUrl: 'dev.ticketpro.store',
        iconLogo:  'assets/images/logo/ticketpro/ticketpro-icon-purple.png',
        tittle: 'TicketPro | All in one ticketing platform for real events',
        organization: 'TicketPro'

    },
    {
        domain: 'default',
        mainLogo: 'assets/images/logo/pro-ticket-logo.png',
        shopRedirectUrl: 'proticket.store',
        iconLogo:  'assets/images/logo/logo-simbolo.png',
        tittle: 'Proticket | All in one ticketing platform for real events',
        organization: 'Proticket'

    },
    {
        domain: 'localhost',
        mainLogo: 'assets/images/logo/pro-ticket-logo.png',
        shopRedirectUrl: 'proticket.store',
        iconLogo:  'assets/images/logo/logo-simbolo.png',
        tittle: 'Proticket | All in one ticketing platform for real events',
        organization: 'Proticket'
    },
]





export interface HostDomainsInterface {
    domain: string;
    mainLogo: string;
    shopRedirectUrl: string;
    iconLogo: string;
    tittle: string;
    organization:string
}